export const events = {
  clickOnCommunityItem: 'Click on community item',
  clickOnCommunityPicker: 'Click on community picker',
  clickOnCreateNewPost: 'Click on create new post',
  clickOnHomeWidgetAction: 'Click on home widget action',
  clickOnHomeWidgetItem: 'Click on home widget item',
  clickOnKudosShareLove: 'Click on kudos share love',
  clickOnSwitchHomeButton: 'Click on switch home button',
  reactToCommunityItem: 'React to community item',
  seeNewHome: 'See new home',
}

export const COMMUNITY_WIDGET_TYPES = {
  CELEBRATIONS: 'celebrations',
  POST: 'post',
}

export const COMMUNITY_ITEM_TYPES = {
  REGULAR_POST: 'regular_post',
  BIRTHDAY: 'birthday',
  WORKIVERSARY: 'workiversary',
  NEW_JOINER: 'new_joiner',
}

export const NEW_HOME_WIDGETS = {
  CLOCK_IN: 'clock-in',
  INBOX: 'inbox',
  EVENTS: 'events',
  COMPANY_LINKS: 'company-links',
  OPEN_POSITIONS: 'open-positions',
  ABSENCES: 'absences',
  HOLIDAYS: 'holidays',
}

export const NEW_HOME_WIDGET_ACTION_TYPES = {
  BOTTOM_BUTTON: 'bottom_button',
  UPPER_RIGHT_BUTTON: 'upper_right_button',
}
